<!-- 
    COMPONENT MINITIELLOGO
-->


<!---------- SCRIPT ---------->

<script lang="ts">

</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">
    .logo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
    }

    .trentesixquinze {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
    }

    .kortefa {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
    }

    .table {
        border-spacing: 1px;
        &__white {
            width: 10px;
            height: 10px;
            background-color: $color_white;
        }
        &__black {
            width: 10px;
            height: 10px;
            background-color: $color_black;
        }
    }

    .spacer {
        width: 5px;
        height: 5px;
    }
    .spacerBig {
        width: 40px;
        height: 15px;
    }

    @include large {
        .logo {
            flex-direction: row;
        }
        .trentesixquinze {
            justify-content: flex-end;
        }
    }

</style>
  
  
<!---------- TEMPLATE ---------->
<div class="logo">
    <div class="spacerBig"></div>
    <div class="kortefa">
        <table id="idK" class="table">
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
        </table>
        <div class="spacer"></div>
        <table id="idO" class="table">
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
        </table>
        <div class="spacer"></div>
        <table id="idR" class="table">
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
        </table>
        <div class="spacer"></div>
        <table id="idT" class="table">
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__black"></td>
                <td class="table__white"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__black"></td>
                <td class="table__white"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__black"></td>
                <td class="table__white"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__black"></td>
                <td class="table__white"></td>
                <td class="table__black"></td>
            </tr>
        </table>
        <div class="spacer"></div>
        <table id="idE" class="table">
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
        </table>
        <div class="spacer"></div>
        <table id="idF" class="table">
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__black"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__black"></td>
            </tr>
        </table>
        <div class="spacer"></div>
        <table id="idA" class="table">
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__white"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
            <tr>
                <td class="table__white"></td>
                <td class="table__black"></td>
                <td class="table__white"></td>
            </tr>
        </table>
    </div>
</div>